import React from "react";
const DateIcon = (props) => {
  const { default_color } = props;
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      height="16"
      width="16"
      //   class="attribute-data-type-icon ic-icon-2 ic-icon-2-small ic-text-letter-icon"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13 5V3h1v2h1c.5 0 1 .5 1 1v8c0 .5-.5 1-1 1H5c-.5 0-1-.5-1-1V6c0-.6.5-1 1-1h1V3h1v2h6zM6 8v5h8V8H6z"
        fill="currentColor"
      ></path>
      <path d="M13 10h-2v2h2v-2z" fill="currentColor"></path>
    </svg>

    // </div>
  );
};
export default DateIcon;
